module.exports = __webpack_public_path__ + "static/media/Family.023d3633.jpg";